import { twMerge } from 'tailwind-merge';

import { CardProps } from './types';

export const Card = ({ children, className }: CardProps) => (
  <div
    className={twMerge('rounded-2xl bg-white p-4 pt-6 shadow-sm', className)}
  >
    {children}
  </div>
);
